import { SignIn } from '@clerk/clerk-react'
import { Box } from '@mui/material'

export const Login = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                pt: '6rem',
                alignItems: 'center',
                width: '100%',
                gap: '1.5rem',
            }}
        >
            <SignIn signUpUrl="/auth/signup" />
        </Box>
    )
}
